import { Object } from "core-js";

export default Object.freeze({
    RedirectToLocker: 0,
    RedirectToClosestPO: 1,
    RedirectToSpecialLocation: 2,
    DeliverToOriginalAddress: 3
});